import React from 'react'

const ForgotPassAdmin = () => {
  return (
    <div>ForgotPassAdmin</div>
  )
}

export default ForgotPassAdmin